module.exports = __webpack_public_path__ + "img/Cash-App-Logo.ee344232.svg";